<template>
    <div class="social-share">
        <div class="text" @click="GTMProdCatClick()">
            <div v-if="!isItCarrier">{{lang('social_share_tetszett_amit_olvastal')}}</div>
            <div v-if="isItCarrier">{{lang('social_share_mast_is_erdekel')}}</div>
            <div>{{lang('social_share_oszd_meg_ismeroseiddel')}}</div>
        </div>
        <a class="facebook-share-icon" :href="'https://www.facebook.com/sharer/sharer.php?u=' + currentSlug" ></a>
    </div>
</template>

<script>
export default {
    data(){
        return{
                      
        }
    },
    computed:{
        currentSlug(){            
            // return window.location.origin + window.location.pathname
            return process.env.VUE_APP_DOMAIN + window.location.pathname
        },
        isItCarrier(){            
            
            if ( window.location.pathname.indexOf("karrier") > -1 || window.location.pathname.indexOf("career") > -1 || window.location.pathname.indexOf("karera") > -1) {
                return true
            } else {
                return false
            }
        }
    },
    methods:{
        GTMProdCatClick(){  
            let contentName = document.querySelectorAll('[data-share-title]')  
            
            if (contentName.length == 0){
                contentName = document.getElementsByTagName("h1")[0].innerHTML
            } else {
                contentName = document.querySelectorAll('[data-share-title]')[0].innerHTML 
            }
            
            this.setDataLayer('fb_share', contentName, '')                  
        }
    }
   
}
</script>